var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AccountLayout',{attrs:{"title":_vm.$t('patient_new.content_title')}},[_c('PatientCreateForm',{on:{"patient-created":_vm.onPatientCreated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }